import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import apiClient from '../api/client';
import './TesteWhatsApp.css';

/**
 * Página SIMPLES de teste do WhatsApp
 * Apenas para verificar se o QR Code é gerado
 */
const TesteWhatsApp = () => {
  const { isAdmin } = useAuth();
  const navigate = useNavigate();
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!isAdmin) {
      navigate('/dashboard');
      return;
    }
    carregarStatus();
  }, [isAdmin, navigate]);

  const carregarStatus = async () => {
    try {
      const response = await apiClient.get('/whatsapp/status');
      setStatus(response.data);
    } catch (err) {
      console.error('Erro ao carregar status:', err);
      setError(err.response?.data?.error || 'Erro ao carregar status');
    }
  };

  const handleTestar = async () => {
    try {
      setLoading(true);
      setError('');
      await apiClient.post('/whatsapp/reconnect');
      alert('Reconexão iniciada! Verifique o terminal do servidor para ver o QR Code.');
      
      // Atualizar status após alguns segundos
      setTimeout(() => carregarStatus(), 3000);
      setTimeout(() => carregarStatus(), 8000);
    } catch (err) {
      console.error('Erro ao testar:', err);
      setError(err.response?.data?.error || 'Erro ao iniciar reconexão');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container teste-whatsapp-container">
      <div className="page-header">
        <h1>🧪 Teste WhatsApp</h1>
        <button onClick={() => navigate('/admin/menu')} className="btn btn-secondary">
          ← Voltar
        </button>
      </div>

      {error && <div className="error">{error}</div>}

      <div className="teste-card">
        <h2>Status Atual</h2>
        <div className="status-info">
          <p><strong>Habilitado:</strong> {status?.enabled ? '✅ Sim' : '❌ Não'}</p>
          <p><strong>Conectado:</strong> {status?.connected ? '✅ Sim' : '❌ Não'}</p>
          <p><strong>QR Code disponível:</strong> {status?.hasQRCode ? '✅ Sim' : '❌ Não'}</p>
          {status?.qrCode && (
            <p><strong>Tamanho do QR Code:</strong> {status.qrCode.length} caracteres</p>
          )}
        </div>

        <div className="teste-actions">
          <button
            onClick={handleTestar}
            className="btn btn-primary"
            disabled={loading}
          >
            {loading ? 'Testando...' : '🔄 Gerar QR Code (Teste)'}
          </button>
          <button
            onClick={carregarStatus}
            className="btn btn-secondary"
          >
            🔄 Atualizar Status
          </button>
        </div>

        <div className="instrucoes">
          <h3>📋 Instruções:</h3>
          <ol>
            <li>Clique em "Gerar QR Code (Teste)"</li>
            <li>Verifique o <strong>terminal do servidor</strong> - o QR Code aparecerá lá</li>
            <li>Escaneie o QR Code com seu WhatsApp</li>
            <li>Clique em "Atualizar Status" para ver se conectou</li>
          </ol>
          <p className="aviso">
            ⚠️ <strong>Importante:</strong> O QR Code aparecerá no terminal onde o servidor está rodando, não nesta página.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TesteWhatsApp;
